import React from 'react';
import classnames from 'classnames';
import CircularProgress from 'material-ui/CircularProgress';
import InfiniteScroll from 'react-infinite-scroller';
import { PRODUCTS_COUNT_IN_A_ROW } from 'swag-client-common/constants';
import { EmptyList } from 'swag-client-common/components/partials/empty-list';
import { SearchProductCard } from '../product-cart';
import classes from '../../search-results.scss';
const styles = {
  searchWrapper: {
    width: '100%'
  },
  searchInfo: {
    textAlign: 'center',
    marginBottom: '0'
  },
  total: {
    textAlign: 'center',
    fontSize: '0.8em'
  },
  productLoader: {
    bottom: '-65px',
    right: '45%',
    position: 'absolute'
  },
  noProductLoader: {
    top: '160px',
    margin: '-0 auto',
    display: 'block'
  }
};
const emptyItemsForCenterAligning = isFilterPopupOpen => Array(PRODUCTS_COUNT_IN_A_ROW).fill(null).map((el, index) => /*#__PURE__*/React.createElement("div", {
  key: `empty-${index}`,
  className: classnames(classes.emptyProductItem, {
    [classes.openedFilter]: isFilterPopupOpen
  })
}));
export function InfiniteProducts({
  lastPage,
  page,
  isLoading,
  subcategories,
  products,
  getProducts,
  isFilterApplied,
  total,
  query,
  error,
  isFilterPopupOpen,
  isLoggedIn
}) {
  if (isLoading && products && products.length === 0) {
    return /*#__PURE__*/React.createElement(CircularProgress, {
      style: styles.noProductLoader
    });
  }
  const items = products ? products.map(item => /*#__PURE__*/React.createElement(SearchProductCard, {
    isLoggedIn: isLoggedIn,
    isFilterPopupOpen: isFilterPopupOpen,
    item: item,
    key: item._id
  })) : [];
  items.push(...emptyItemsForCenterAligning(isFilterPopupOpen));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.infiniteScrollWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.spacer, {
      [classes.activeFilter]: isFilterPopupOpen
    })
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    className: classnames(classes.itemsContainer, {
      [classes.itemsWithoutSubcategoryContainer]: !subcategories,
      [classes.itemsWithAppliedFilters]: isFilterApplied,
      [classes.itemsWithOpenFilterDrawer]: isFilterPopupOpen
    }),
    loadMore: () => getProducts({
      page: page + 1
    }),
    hasMore: page < lastPage && !isLoading && !!query && !error,
    loader: /*#__PURE__*/React.createElement(CircularProgress, {
      style: styles.productLoader
    })
  }, query && /*#__PURE__*/React.createElement("div", {
    style: styles.searchWrapper
  }, /*#__PURE__*/React.createElement("p", {
    style: styles.searchInfo,
    "data-text": "YouSearched"
  }, "You searched \"", query, "\""), /*#__PURE__*/React.createElement("p", {
    style: styles.total,
    "data-text": "ResultsQuantity"
  }, `${total} result${total > 1 ? 's' : ''}`)), items.length !== PRODUCTS_COUNT_IN_A_ROW ? items : /*#__PURE__*/React.createElement(EmptyList, {
    wrapperClassName: classnames({
      [classes.emptyWithOpenedDrawer]: isFilterPopupOpen
    }),
    title: "No products match your selection"
  }))));
}